import { Link } from "react-router-dom";
import { Pizza } from "lucide-react";

const sections = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Overview", "This placeholder Privacy Policy explains how Regulars Club ('we', 'us') collects and uses information when restaurants and members use the platform. Replace this text with your finalized policy before going live."],
      ["Information We Collect", "We collect information you provide directly: your name, email address, and phone number when you create an account or subscribe to a membership. Restaurant owners also provide business details."],
      ["Payments", "Payments are processed securely by Stripe. We do not store your full card number. Card data is handled by Stripe under their PCI-compliant infrastructure. For restaurants using Stripe Connect, member payments are processed directly by the restaurant's connected Stripe account."],
      ["How We Use Information", "We use your information to operate memberships, send transactional messages (email/SMS) such as welcome notes, payment reminders, and reward notifications, and to provide restaurant owners with member management tools."],
      ["Data Sharing", "We share member details (name, email, phone, subscription status) with the specific restaurant a member subscribes to. We do not sell your personal information."],
      ["Your Choices", "You may update or delete your account information, cancel a membership at any time, and opt out of non-essential communications."],
      ["Contact", "Questions about this policy? Contact us by email at Theregularsclubmember@gmail.com."],
    ],
  },
  terms: {
    title: "Terms and Conditions",
    body: [
      ["Acceptance", "This placeholder Terms of Service governs your use of Regulars Club. By creating an account you agree to these terms. Replace this text with your finalized terms before going live."],
      ["Memberships & Billing", "Member subscriptions renew automatically each month until canceled. When you cancel, your membership remains active until the end of the current paid period, after which it will not renew. Prices are set by each restaurant."],
      ["Platform Fee", "Restaurant owners are charged a recurring monthly platform fee to operate their club. Member payments may be processed directly to the restaurant via Stripe Connect."],
      ["Refunds", "Refund terms are set by each restaurant. Platform fees are generally non-refundable except where required by law."],
      ["Acceptable Use", "You agree not to misuse the platform, attempt unauthorized access, or use another member's card or account."],
      ["Rewards", "Rewards and perks are offered at each restaurant's discretion and may change. Redemption codes are valid only at the issuing restaurant."],
      ["Notifications", "By providing your email address and phone number, you consent to receive transactional messages related to your account and membership — including welcome messages, renewal and payment reminders, cancellation notices, and reward alerts — via email and SMS. Message and data rates may apply. Reply STOP to any SMS to opt out."],
      ["Limitation of Liability", "The platform is provided 'as is'. To the extent permitted by law, we are not liable for indirect or incidental damages."],
      ["Contact", "For questions about these terms, contact us by email at Theregularsclubmember@gmail.com."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const s = sections[kind];
  return (
    <div className="App min-h-screen bg-[#FFF4E6]">
      <header className="border-b border-[#17324D]/15 bg-[#FFF4E6]">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2">
            <span className="bg-[#D94A3D] text-white p-1.5 rounded-xl border border-[#17324D]/15"><Pizza size={20} strokeWidth={2.5} /></span>
            <span className="font-heading font-bold text-lg">REGULARS CLUB</span>
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12" data-testid={`legal-${kind}`}>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">{s.title}</h1>
        <p className="text-sm text-[#17324D]/60 mt-1">Last updated: placeholder — replace before launch.</p>
        <div className="mt-8 space-y-6">
          {s.body.map(([h, p], i) => (
            <section key={i}>
              <h2 className="font-semibold text-lg">{h}</h2>
              <p className="text-[#17324D]/80 mt-1 leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <div className="mt-10 flex gap-4 text-sm">
          <Link to="/privacy" className="underline text-[#D94A3D]">Privacy</Link>
          <Link to="/terms" className="underline text-[#D94A3D]">Terms</Link>
          <Link to="/" className="underline">Home</Link>
        </div>
      </main>
    </div>
  );
}
